import Joi from 'joi';



export const createStatutorySchema = () => {
    return Joi.object({
        esi_availability: Joi.boolean().required(),

        esic_registration_date: Joi.string()
            .when('esi_availability', {
                is: true,
                then: Joi.required().messages({
                    'any.required': 'ESI Registration Date is required.',
                    'string.empty': 'ESI Registration Date cannot be empty.',
                }),
                otherwise: Joi.optional()
            }),

      

        esic_insurance_number: Joi.string()
            .when('esi_availability', {
                is: true,
                then:  Joi.string()
                .required()
                .pattern(/^\d{10}$/)
                    .messages({
                        'string.pattern.name': 'ESI Insurance Number must be exactly 10 digits.',
                        'any.required': 'ESI Insurance Number is required.',
                        'string.empty': 'ESI Insurance Number must be a 10-digit number and cannot be empty.',
                        'string.pattern.base': 'ESI Insurance Number must be exactly 10 digits and contain only numbers.',

                    }),
                otherwise: Joi.optional()
            }),

    }).unknown(true);
};




export const createStatutorySchemaEPF = () => {
    return Joi.object({
        epf_availability: Joi.boolean().required(),
        member_payroll: Joi.boolean()
            .required()
            .messages({
                'any.required': 'Please select member payroll.',
                'boolean.base': 'Member payroll must be either Yes or No.',
            }),
          epf_id_ac_no: Joi.string().when('member_payroll', {
                is: true,
                then: Joi.string()
                    .required()
                    .pattern(/^[A-Z]{2}[A-Z]{3}\d{7}\d{3}\d{7}$/) 
                    .messages({
                        'string.empty': 'Emp id Ac No is required when Member Payroll is "Yes".',
                        'string.pattern.base': 'Emp id Ac No must be in the format of two letters, three letters, seven digits, three digits, and seven digits (e.g., XXABC12345678901234567).'
                    }),
                otherwise: Joi.allow('')
            }),
            uan_no: Joi.string()
            .when('epf_availability', {
                is: true,
                then: Joi.string()
                    .required()
                    .pattern(/^\d{12}$/)
                    .messages({
                        'string.empty': 'UAN number is required.',
                        'string.pattern.base': 'UAN number must be a 12-digit number.',
                        'any.required': 'UAN number is required.',
                    }),
                otherwise: Joi.optional(),
            }),
            retired_govt_employee: Joi.boolean()
            .required()
            .messages({
                'any.required': 'Retired government employee field is required.',
                'boolean.base': 'Retired government employee must be either Yes or No.',
            }),
        
        ppo_no:  Joi.string().when('retired_govt_employee', {
            is: true,
            then: Joi.string()
                .required().pattern(/^\d{12}$/) 
                    .messages({
                        'string.empty': 'PPO No is required when Retired govt employee is Yes.',
                        'string.pattern.base': 'PPO No must be a 12-digit number.',
                        'any.required': 'PPO No is required when Retired govt employee is Yes.',
                    }),
                otherwise: Joi.optional().allow(null,""), 
            }),
        employee_contribution: Joi.string()
            .required()
            .messages({
                'any.required': 'Employee contribution is required',
                'string.empty': 'Employee contribution cannot be empty',
            }),
        epf_registration_date: Joi.string().allow('').optional(),
        // epf_uan_attachment: Joi.binary().optional(),
    }).unknown(true);
};


export const createBankSchema = () => {
    return Joi.object({
        bank_name: Joi.string().required().messages({

            "string.empty": "Bank name is required.",
            "any.required": "Bank name must be a string",
            "any.invalid": "Bank name is required."
        }),
        branch_name: Joi.string().required().messages({
            "string.empty": "Branch name is required.",
            'string.base': 'Branch name must be a string.',
            'any.required': 'Branch name is required.',
        }),
        account_number: Joi.string()
            .pattern(/^\d{9,18}$/)
            .required()
            .messages({
                "string.empty": "Account number is required.",
                'string.pattern.base': 'Account number must be between 9 to 18 digits.',
                'any.required': 'Account number is required.',
            }),
        ifsc_code: Joi.string()
            .pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/)
            .required()
            .messages({
                "string.empty": "IFSC is required.",
                'string.pattern.base': 'IFSC code must follow the format: 4 letters + 0 + 6 alphanumeric characters.',
                'any.required': 'IFSC code is required.',
            }),
            payment_through: Joi.string()
            .required()
            .messages({
                "string.empty": "Payment Through is required.",
                'string.base': 'Payment Through must be a string.',
                'any.required': 'Payment Through is required.',
            }),
    }).unknown(true);
};